/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { fromJS } from 'immutable';
import ActionTypes from './ActionTypes';
import Raven from 'raven-js';
import { AWARD_VISIBILITIES } from '../constants/TracksConstants';
import { putAchievementUpdate, fetchAchievementsAll } from '../api/AchievementsApi';
import { serializableError } from '../utils/utils';
import { denormalizePublicAchievementResponse, GET_ACHIEVEMENT_BY_PUBLIC_ID, GET_ALL_ACHIEVEMENTS } from '../features/achievement/achievementQueries';
import { dataFetchingClient } from '../utils/DataFetchingClient';
export const fetchAllAchievements = preferredLanguage => dispatch => {
  dispatch({
    type: ActionTypes.ACHIEVEMENTS_ALL_REQUESTING
  });
  fetchAchievementsAll().then(response => {
    const denormalizedResponse = denormalizePublicAchievementResponse(response);
    dataFetchingClient.writeQuery({
      query: GET_ALL_ACHIEVEMENTS,
      variables: {
        language: preferredLanguage
      },
      data: {
        allAchievements: denormalizedResponse
      }
    });
    Object.keys(denormalizedResponse).forEach(publicId => {
      dataFetchingClient.writeQuery({
        query: GET_ACHIEVEMENT_BY_PUBLIC_ID,
        variables: {
          publicId,
          language: preferredLanguage
        },
        data: {
          achievementByPublicId: denormalizedResponse[publicId]
        }
      });
    });
    return dispatch({
      type: ActionTypes.ACHIEVEMENTS_ALL_RECEIVED,
      payload: {
        preferredLanguage,
        response: fromJS(response)
      }
    });
  }, error => dispatch({
    type: ActionTypes.ACHIEVEMENTS_ALL_ERROR,
    error: true,
    payload: serializableError(error)
  }));
};
export const updateAchievement = (achievement, shouldBePublic, metadata) => dispatch => {
  const publicId = achievement.get('publicId');
  const putData = achievement.withMutations(ach => {
    if (shouldBePublic === ach.get('private')) {
      ach.merge({
        private: !shouldBePublic,
        visibilityType: shouldBePublic ? AWARD_VISIBILITIES.PUBLIC : AWARD_VISIBILITIES.PRIVATE
      });
    }
    if (metadata) {
      ach.mergeIn(['metadata'], metadata);
    }
  });
  Raven.captureBreadcrumb({
    message: 'Updating existing achievement',
    category: 'Achievements',
    data: putData.toJS()
  });
  dispatch({
    type: ActionTypes.ACHIEVEMENT_UPDATE_REQUESTING,
    payload: {
      publicId
    }
  });
  putAchievementUpdate(publicId, putData.toJS()).then(() => dispatch({
    type: ActionTypes.ACHIEVEMENT_UPDATE_SUCCEEDED,
    payload: {
      publicId,
      data: putData
    }
  }), error => dispatch({
    type: ActionTypes.ACHIEVEMENT_UPDATE_ERROR,
    error: true,
    payload: serializableError(error)
  }));
};